export default __webpack_public_path__ + "static/media/Cart.01ab1bd0.svg";